import classnames from "classnames";
import React from "react";

interface Props extends Pick<React.ImgHTMLAttributes<HTMLImageElement>, "alt" | "className" | "height" | "width"> {
  type: "light" | "dark" | "colour";
}

const defaultAlt = "TravelLocal is a member of ASTA - book with confidence.";

/**
 * The ASTA logo.
 * 
 * @status stable
 */
export const AstaLogo: React.FC<Props> = ({ type, alt, className, ...rest }) => {
  const imgClassName = classnames("lazyload", "asta-logo", `asta-logo--${type}`, className);
  const altText = alt ?? defaultAlt;
  const path = `/images/logos/ASTA_logo_${type}.svg`;

  return (
    <img {...rest} className={imgClassName} alt={altText} title={altText} data-src={path} />
  );
};

AstaLogo.defaultProps = {
  alt: defaultAlt,
};
